import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Makeup Removal";

const callMakeupRemover = async (
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
				},
				jwt,
				tool_document_id,
			};
			return fetchMakeupRemover(data, executionContext, messageId);
		},
	});
	return success;
};

export type InferenceParams = {
	inputs: {
		$img: string;
	};
	jwt: string;
	tool_document_id: string;
};

export async function fetchMakeupRemover(
	params: InferenceParams,
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenMakeupRemoverMessage() {
	useListenFromRenderer([
		{
			key: "makeupRemover",
			onMessage: async (message) => {
				const success = await callMakeupRemover(
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
